import { Dtos, ErrorKey, SuretyAccountId } from "@inrev/common";
import { useGlobalErrorMessageModal } from "@portal/providers/GlobalErrorHandlingProvider";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiError, logError } from "../../../utils/error";
import { useRequest } from "../../../utils/request";
import { accountLatestIndemnityAgreementQueryKey, accountQueryKey } from "../account.keys";

export const useAdminCreateAccountIndemnityAgreement = () => {
	const { post } = useRequest();
	const queryClient = useQueryClient();
	const { triggerErrorModal } = useGlobalErrorMessageModal();

	const mutation = useMutation({
		mutationFn: async (args: {
			accountId: SuretyAccountId;
			data: Dtos.IndemnityAgreement.Create.Request;
		}) => {
			return await post(
				`/v2/admin/surety/accounts/${args.accountId}/indemnity-agreements`,
				args.data,
				"none",
			);
		},
		onSuccess: (_data, variables) => {
			queryClient.invalidateQueries({ queryKey: accountQueryKey(variables.accountId) });
			queryClient.invalidateQueries({
				queryKey: accountLatestIndemnityAgreementQueryKey(variables.accountId),
			});
		},
		onError: (error: Error) => {
			logError(error);
			if (error instanceof ApiError && error.key === ErrorKey.indemnity_exists) {
				triggerErrorModal(error, { severity: "warn" });
			} else {
				triggerErrorModal(error);
			}
		},
	});

	return {
		createAccountIndemnityAgreement: mutation.mutateAsync,
		createAccountIndemnityAgreementIsLoading: mutation.isPending,
	};
};
